function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="14" height="19" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M7.502 1.603a.688.688 0 0 0-1.15 0C4.909 3.879 1.249 9.892 1.249 12.306c0 3.009 2.542 5.447 5.678 5.447s5.679-2.438 5.679-5.447c0-2.414-3.66-8.427-5.104-10.703zM3.167 12.33c0 1.568 1.123 2.885 2.64 3.25" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round" /></svg>;
});